import React, { Component } from "react";
import PageHelmet from "./Helmet";
import { FiHeadphones , FiMail , FiMapPin } from "react-icons/fi";
import ContactThree from "./ContactThree";
import BrandTwo from "./BrandTwo";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../Layout/Main/header/Header";
import Footer from "../../Layout/Main/footer/FooterTwo";
import BackgroungImg from "../../assets/images/service/Banner 01 (002).jpg"
const AnyReactComponent = ({ text }) => <div>{text}</div>;

class ClientInformation extends Component{
    componentDidMount =() =>{
   //     setTimeout(() => {
            window.scrollTo(0, 0);
            console.log("HELLLOOW")
       //     }, 600);
            
    }
    static defaultProps = {
        center: {
            lat: 59.95,
            lng: 30.33
        },
        zoom: 11
    };

    render(){
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Client Information' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                 {/* Start Breadcrump Area */}
                 
                {/* End Breadcrump Area */}


                {/* Start Contact Top Area  */}
                <div className="rn-contact-top-area">
                    <div className="container">
                        <div className="row">
                    
                        </div>
                    </div>
                </div>
                {/* End Contact Top Area  */}

                {/* Start Contact Page Area  */}
                <div className="rn-contact-page ptb--120 bg_color--1">
                    <ContactThree />
                </div>

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />
                
            </React.Fragment>
        )
    }
}
export default ClientInformation